import React from "react";
import moment from "moment-timezone";

const buildCopy = (lockState) => {
  if (lockState?.source === "manual") {
    const who = lockState.lockedBy?.name || "an Admin";

    if (!lockState.lockedAt) {
      return `This Trip was locked by ${who}. Contact an Admin to make changes.`;
    }

    const when = moment(lockState.lockedAt).tz("America/New_York");
    return `This Trip was locked by ${who} on ${when.format(
      "MMMM Do, YYYY",
    )} at ${when.format("h:mm A")} ET. Contact an Admin to make changes.`;
  }

  if (lockState?.deadlineFormatted) {
    return `Verification window closed on ${lockState.deadlineFormatted}. This Trip was not verified in time and is now locked. Contact an Admin to make changes.`;
  }

  return "This Trip is locked. Contact an Admin to make changes.";
};

const LockedBlock = ({ trip, canUnlock, onUnlock, className = "" }) => {
  const lockState = trip?.lockState;

  if (!lockState?.locked || trip?.verified) return null;

  return (
    <div className={`tv-locked-wrap ${className}`.trim()}>
      <div className="tv-locked">
        <span className="material-icons">lock</span>
        <span>{buildCopy(lockState)}</span>
      </div>

      {canUnlock && (
        <button
          type="button"
          className="base-button evo-gunmetal tv-locked-button"
          onClick={onUnlock}
        >
          Unlock Trip
        </button>
      )}
    </div>
  );
};

export default LockedBlock;
